/* eslint-disable camelcase */
const en_USLang = {
  translation: {
    home: {
      heading: 'Theme Test',
    },
  },
};
export default en_USLang;
